import React from 'react';
import { Button, Grid, TableBody, TableCell, TableRow, withStyles } from '@material-ui/core';
import moment from 'moment';

import axiosInstance, { addComma, EVENT_ID, readFile, getUserID, WEB_API } from '../constatns';
import {
  EARLY_REGISTRATION_FEE,
  REGULAR_REGISTRATION_FEE,
  ONSITE_REGISTRATION_FEE,
  // RESIDENT_TABLE,
  OVERSEA_EARLY_REGISTRATION_FEE,
  OVERSEA_REGULAR_REGISTRATION_FEE,
  OVERSEA_ONSITE_REGISTRATION_FEE,
} from './RegistrationConstants';
import SubTitle from '../components/Text/SubTitle';
import ConfirmButton from '../components/Button/ConfirmButton';
import Table from '../components/Table/Table';
import { AiOutlineEdit } from 'react-icons/ai';

import DocUploadForm from './DocUploadForm';

import UploadToS3Alt from '../common/UploadToS3Alt';
import swal from 'sweetalert';

const PREVIEW_KEY = [
  {
    order: 1,
    key: 'regNo',
    value: 'Registration No.',
    valueEng: 'Registration No.',
  },
  {
    order: 2,
    key: 'regDate',
    value: 'Registration Date',
    valueEng: 'Registration Date',
  },
  {
    order: 3,
    key: 'username',
    value: 'Name',
    valueEng: 'Name',
  },
  {
    order: 4,
    key: 'cate1',
    value: 'Category',
    valueEng: 'Category',
  },

  // {
  //   order: 5,
  //   key: 'attach',
  //   value: 'Document for proof of Resident',
  //   valueEng: 'Document for proof of Resident',
  // },
  {
    order: 5,
    key: 'amount',
    value: '등록비',
    valueEng: 'Registration Fee',
  },
  {
    order: 6,
    key: 'cate3',
    value: '국제학회(ICOPLAST) 연회비',
    valueEng: 'ICOPLAST Annual Fee',
  },
  {
    order: 7,
    key: 'cate4',
    value: '학회지 (APS) 발전기금',
    valueEng: 'APS Application',
  },
  // {
  //   order: 9,
  //   key: 'isDinner',
  //   value: 'Gala Dinner',
  //   valueEng: 'Gala Dinner',
  // },
  {
    order: 8,
    key: 'amount',
    value: '결제금액',
    valueEng: 'Payment Amount',
  },
  {
    order: 9,
    key: 'payType',
    value: '결제수단',
    valueEng: 'Payment Type',
  },
  {
    order: 10,
    key: 'extraPayType',
    value: '추가요금 결제수단',
    valueEng: 'Extra Charge Payment Type',
  },
  {
    order: 11,
    key: 'status',
    value: '결제상태',
    valueEng: 'Payment Status',
  },
  {
    order: 12,
    key: 'depositor',
    value: '송금자명',
    valueEng: 'Depositor',
  },
  {
    order: 13,
    key: 'depositDate',
    value: '송금예정일',
    valueEng: 'Deposit Date',
  },
  {
    order: 14,
    key: 'extraDepositor',
    value: '추가요금 송금자명',
    valueEng: 'Extra Charge Depositor',
  },
  {
    order: 15,
    key: 'extraDepositDate',
    value: '추가요금 송금예정일',
    valueEng: 'Extra Charge Deposit Date',
  },
];

const styles = (theme) => ({
  tableBorder: {
    '& th:not(:last-child)': {
      borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
    '& td:not(:last-child)': {
      borderRight: '1px solid rgba(224, 224, 224, 1)',
    },
  },
  tableHeadAlignCenter: {
    '& th': {
      textAlign: 'center',
    },
  },
  tableBodyAlignCenter: {
    '& td': {
      textAlign: 'center',
    },
  },

  marginTop30px: {
    marginTop: 30,
  },
});

class RegistrationPreview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        id: 'DR-9589',
        createdAt: 1621584042031,
        name: 'Nakyeong Ha',
        category: '전공의',
        total: 70000,
        paymentMethod: 'Bank Transfer',
        status: 'Completed',
        remitterName: '하나경',
        remittanceDate: '2021-08-09',
      },

      // 무료등록 회원인 경우에 한해
      isAnnualChecked: false, //국제학회(ICOPLAST) 연회비
      isJournalChecked: false, //학회지(APS)
      totalAmount: 0, //위의 항목들 신청했을때
      figures: [''], //첨부파일
      toggleEdit: false,
    };

    this.handleChangeImg = this.handleChangeImg.bind(this);
    this.clickUploadImg = this.clickUploadImg.bind(this);
    this.deleteImg = this.deleteImg.bind(this);
    this.saveChange = this.saveChange.bind(this);
  }

  openReceipt() {
    window.open(`/#/registration/receipt?Receipt`, '_blank', 'width=600 ,height=800');
  }

  // openCertificate(id) {
  openCertificate() {
    // window.open(`/#/registration/certificate?id=${id}`, '_blank', 'width=960 ,height=730');

    // DB에 바로 등록 등, 등록 번호 없는 무료 사용자 존재
    window.open(`/#/registration/certificate?id=Certificate`, '_blank', 'width=960 ,height=730');
  }

  renderFreeMember() {
    const { userInfo, lang } = this.props;
    // const { isAnnualChecked, isJournalChecked, totalAmount } = this.state;
    // console.log(userInfo);
    return (
      <>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell component={'th'} width={'25%'} align={'center'}>
                Name
              </TableCell>
              <TableCell width={'75%'}>{userInfo.username}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'} width={'25%'} align={'center'}>
                Category
              </TableCell>
              <TableCell width={'75%'}>{lang === 'kor' ? '무료등록' : 'Free'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'} width={'25%'} align={'center'}>
                {lang === 'kor' ? '등록비' : 'Registration Fee'}
              </TableCell>
              <TableCell width={'75%'}>{lang === 'kor' ? 'KRW' : 'USD'} 0</TableCell>
            </TableRow>
            {lang === 'kor' && (
              <>
                <TableRow>
                  <TableCell component={'th'} width={'25%'} align={'center'}>
                    국제학회(ICOPLAST) 연회비
                  </TableCell>
                  <TableCell width={'75%'}>{userInfo.cate3 ? 'KRW 15,000' : 'KRW 0'}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell component={'th'} width={'25%'} align={'center'}>
                    학회지(APS) 발전기금
                  </TableCell>
                  <TableCell width={'75%'}>{userInfo.cate4 ? 'KRW 20,000' : 'KRW 0'}</TableCell>
                </TableRow>
              </>
            )}

            {/* <TableRow>
              <TableCell component={'th'} width={'25%'} align={'center'}>

                Gala Dinner
              </TableCell>

              <TableCell width={'75%'}>
                {lang === 'kor' ? (
                  <>{userInfo.isDinner === 'O' ? 'KRW 30,000' : 'X'}</>
                ) : (
                  <>{userInfo.isDinner === 'O' ? 'USD 30' : 'USD 0'}</>
                )}
              </TableCell>
            </TableRow> */}
            <TableRow>
              <TableCell component={'th'} width={'25%'} align={'center'}>
                {lang === 'kor' ? '결제금액' : 'Total Amount'}
              </TableCell>
              <TableCell width={'75%'}>
                {lang === 'kor' ? 'KRW' : 'USD'} {addComma(userInfo.amount)}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'} width={'25%'} align={'center'}>
                {lang === 'kor' ? '결제수단' : 'Payment Method'}
              </TableCell>
              <TableCell width={'75%'}>Bank Transfer</TableCell>
            </TableRow>
            <TableRow>
              <TableCell component={'th'} width={'25%'} align={'center'}>
                {lang === 'kor' ? '결제상태' : 'Payment Status'}
              </TableCell>
              <TableCell width={'75%'}>
                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                  <span style={{ color: '#00f', marginRight: '0.5em' }}>Completed</span>
                  <Button
                    variant="contained"
                    color="secondary"
                    size="large"
                    disableElevation
                    // onClick={() => this.openReceipt(this.props.userInfo.regNo)}
                    onClick={() => this.openReceipt()}
                    style={{ marginLeft: '8px', color: '#fff', textTransform: 'none', width: '140px' }}
                  >
                    Receipt
                  </Button>

                  {/* 무료등록 이수증 */}
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    disableElevation
                    // onClick={() => this.openCertificate(this.props.userInfo.regNo)}
                    onClick={() => {
                      if (moment().tz('Asia/Seoul').isAfter(moment('2022-11-11 08:00:00'))) {
                        this.openCertificate();
                      } else {
                        swal('', 'Available for download from 2022-11-13 18:30(KST)', 'info');
                      }
                    }}
                    style={{ marginLeft: '8px', textTransform: 'none', width: '140px' }}
                  >
                    Certificate
                  </Button>
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>

        {/* <div className={classes.marginTop30px}>
          <Table>
            <TableHead className={classes.tableBorder}>
              <TableRow>
                <TableCell colSpan={2}>국제학회(ICOPLAST) 연회비 납부</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell component={'th'} width={'30%'} align={'center'}>
                  국제학회(ICOPLAST) 연회비
                </TableCell>
                <TableCell width={'70%'} align={'center'}>
                  <Checkbox
                    color="primary"
                    checked={isAnnualChecked}
                    value={15000}
                    onChange={(e) => {
                      if (e.target.checked) {
                        this.setState((prevState) => ({
                          isAnnualChecked: true,
                          totalAmount: prevState['totalAmount'] + 15000,
                        }));
                      } else {
                        this.setState((prevState) => ({
                          isAnnualChecked: false,
                          totalAmount: prevState['totalAmount'] - 15000,
                        }));
                      }
                    }}
                  />
                  KRW 15,000
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Grid container style={{ marginTop: '1em' }}>
            <Grid item xs={2} style={{ textAlign: 'center' }}>
              <img src={`${EVENT_IMG}/registration/icoplast_logo.png`} alt="" width="100%" />
            </Grid>
            <Grid item xs={10} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <p style={{ fontWeight: 'bold', marginBottom: '0.5em' }}>ICOPLAST 연회비 납부</p>
              <p>
                우리 학회는 ICOPLAST(INTERNATIONAL CONFEDERATION OF PLASTIC SURGERY SOCIETIES) 상임이사국으로서 대한성형외과학회의 정회원은
                ICOPLAST의 회원자격을 가지고 있으며 회비납부의 의무를 가지고 있습니다.{' '}
              </p>
            </Grid>
          </Grid>
        </div>

        <div className={classes.marginTop30px}>
          <Table>
            <TableHead className={classes.tableBorder}>
              <TableRow>
                <TableCell colSpan={2}>학회지(APS) 신청</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell component={'th'} width={'30%'} align={'center'}>
                  학회지(APS) 신청
                </TableCell>
                <TableCell width={'70%'} align={'center'}>
                  <Checkbox
                    color="primary"
                    checked={isJournalChecked}
                    value={20000}
                    onChange={(e) => {
                      if (e.target.checked) {
                        this.setState((prevState) => ({
                          isJournalChecked: true,
                          totalAmount: prevState['totalAmount'] + 20000,
                        }));
                      } else {
                        this.setState((prevState) => ({
                          isJournalChecked: false,
                          totalAmount: prevState['totalAmount'] - 20000,
                        }));
                      }
                    }}
                  />
                  KRW 20,000
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Grid container style={{ marginTop: '1em' }}>
            <Grid item xs={2} style={{ textAlign: 'center' }}>
              <img src={`${EVENT_IMG}/registration/aps_logo.png`} width="50%" alt="" />
            </Grid>
            <Grid item xs={10} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <p style={{ fontWeight: 'bold', marginBottom: '0.5em' }}>학회지 신청 (Archives of Plastic Surgery) 신청</p>
              <p>
                Archives of Plastic Surgery는 구독 신청자에게만 발송하고 있으며, 구독을 원하시는 분께는 학회지 발전금으로 유용하게 쓰일 회비
                20,000원을 받고 있습니다.
              </p>
            </Grid>
          </Grid>
        </div>

        <div className={classes.marginTop30px}>
          <Table>
            <TableBody className={`${classes.tableBorder} ${classes.tableHeadAlignCenter} ${classes.tableBodyAlignCenter}`}>
              <TableRow>
                <TableCell component={'th'} width={'25%'}>
                  합계
                </TableCell>
                <TableCell width={'75%'}>KRW {addComma(totalAmount)}</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div> */}
      </>
    );
  }

  renderBankTransfer() {
    return (
      <Table>
        <TableBody>
          <TableRow>
            <TableCell component={'th'} align={'center'}>
              {this.props.userInfo.country.indexOf('Korea') !== -1 ? '은행명' : 'Bank Name'}
            </TableCell>
            <TableCell>{this.props.userInfo.country.indexOf('Korea') !== -1 ? '하나은행' : 'Hana Bank'}</TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'} align={'center'}>
              {this.props.userInfo.country.indexOf('Korea') !== -1 ? '계좌명' : 'Beneficiary Account'}
            </TableCell>
            <TableCell>
              {this.props.userInfo.country.indexOf('Korea') !== -1
                ? '대한성형외과학회'
                : 'Korean Society of Plastic and Reconstructive Surgeons (KSPRS)'}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component={'th'} align={'center'}>
              {this.props.userInfo.country.indexOf('Korea') !== -1 ? '계좌번호' : 'Account Number'}
            </TableCell>
            <TableCell colSpan={3}>
              {this.props.userInfo.country.indexOf('Korea') !== -1 ? '261-910022-59704' : '224-910007-31232'}
            </TableCell>
          </TableRow>
          {this.props.userInfo.country.indexOf('Korea') === -1 && (
            <>
              <TableRow>
                <TableCell component={'th'} align={'center'}>
                  Swift Code
                </TableCell>
                <TableCell colSpan={3}>KOEXKRSE or KOEXKRSEXXX</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component={'th'} align={'center'}>
                  Branch Name
                </TableCell>
                <TableCell colSpan={3}>Seochonam Banking Center</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component={'th'} align={'center'}>
                  Bank Address
                </TableCell>
                <TableCell colSpan={3}>06733, Seoun-ro 3, Seocho-gu, Seoul</TableCell>
              </TableRow>
              <TableRow>
                <TableCell component={'th'} align={'center'}>
                  Contact Information
                </TableCell>
                <TableCell colSpan={3}>+82-2-3472-1111​</TableCell>
              </TableRow>
            </>
          )}
        </TableBody>
      </Table>
    );
  }

  renderRegistrationDetail() {
    return (
      <Table>
        <TableBody>
          {PREVIEW_KEY.map((p, idx) => {
            // console.log('p:', p);
            if (this.props.userInfo.payType !== 'bank') {
              if (p.key !== 'depositor' && p.key !== 'depositDate' && p.key !== 'extraDepositor' && p.key !== 'extraDepositDate') {
                if (this.props.userInfo.country.indexOf('Korea') !== -1) {
                  if (this.props.userInfo.isExtraCharge) {
                    return this.renderTableRow(p, idx);
                  } else {
                    if (p.key !== 'extraPayType') return this.renderTableRow(p, idx);
                  }
                } else {
                  if (this.props.lang !== 'kor' && this.props.userInfo.isExtraCharge) {
                    if (p.key !== 'cate3' && p.key !== 'cate4') return this.renderTableRow(p, idx);
                  } else {
                    if (p.key !== 'extraPayType' && p.key !== 'cate3' && p.key !== 'cate4') return this.renderTableRow(p, idx);
                  }
                }
              }
            } else {
              if (this.props.lang !== 'kor' && this.props.userInfo.isExtraCharge) {
                if (this.props.userInfo?.extraPayType === 'bank') {
                  if (p.key !== 'cate3' && p.key !== 'cate4') return this.renderTableRow(p, idx);
                } else {
                  if (p.key !== 'cate3' && p.key !== 'cate4' && p.key !== 'extraDepositor' && p.key !== 'extraDepositDate')
                    return this.renderTableRow(p, idx);
                }
              } else {
                if (p.key !== 'extraPayType' && p.key !== 'extraDepositor' && p.key !== 'extraDepositDate') {
                  if (this.props.userInfo.country.indexOf('Korea') !== -1) {
                    return this.renderTableRow(p, idx);
                  } else {
                    if (p.key !== 'cate3' && p.key !== 'cate4') return this.renderTableRow(p, idx);
                  }
                }
              }
            }
          })}
          {this.props.userInfo.cate1 === 'International Trainee(UAE)' && (
            <TableRow>
              <TableCell component={'th'} width={'25%'} align={'center'}>
                Document for proof of Resident
              </TableCell>
              <TableCell width={'75%'}>
                <Grid container>
                  <Grid style={{ marginBottom: 8 }}>
                    <span onClick={(e) => this.handleDownload(this.props.userInfo.attach)} style={{ cursor: 'pointer' }}>
                      <u>{this.props.userInfo.attach && this.props.userInfo.attach.replace('evt120_', '').replace('%40', '@')}</u>
                    </span>

                    <Button
                      color="primary"
                      variant="contained"
                      style={{ marginLeft: 16 }}
                      onClick={() => {
                        this.setState({ toggleEdit: !this.state.toggleEdit });
                      }}
                    >
                      Edit
                    </Button>

                    {this.state.figures[0] && (
                      <Button color="primary" variant="contained" style={{ marginLeft: 16 }} onClick={this.saveChange}>
                        SAVE
                      </Button>
                    )}
                  </Grid>
                  {this.state.toggleEdit === true && (
                    <DocUploadForm
                      setOfFigures={1}
                      handleChangeImg={this.handleChangeImg}
                      clickUploadImg={this.clickUploadImg}
                      deleteImg={this.deleteImg.bind(this)}
                      figures={this.state.figures}
                    />
                  )}
                </Grid>
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    );
  }

  categoryannual = (prevData) => {
    const kind = this.props.userInfo.kind;
    let annual = prevData ? prevData : '';

    if (annual === '전공의') {
      if (this.props.userInfo?.cate2) {
        annual += ' (' + this.props.userInfo.cate2.split('의')[1] + ')';
      }
    }
    return annual;
  };

  calculateRegistrationFee = (userInfo) => {
    const { country, regType, cate1, lang } = userInfo;
    let buff = 0;
    let refTable = 0;

    const tables = [
      EARLY_REGISTRATION_FEE,
      REGULAR_REGISTRATION_FEE,
      ONSITE_REGISTRATION_FEE,
      OVERSEA_EARLY_REGISTRATION_FEE,
      OVERSEA_REGULAR_REGISTRATION_FEE,
      OVERSEA_ONSITE_REGISTRATION_FEE,
    ];

    // console.log(tables);

    // 어느 요금표 배열 참고해야하는지
    switch (regType) {
      case 'R1':
        // 조기등록
        refTable = country.indexOf('Korea') !== -1 ? 0 : 3;
        break;
      case 'R2':
        // 사전등록
        refTable = country.indexOf('Korea') !== -1 ? 1 : 4;
        break;
      case 'R3':
        // 현장등록
        refTable = lang === 'kor' ? 2 : 5;
        break;
    }
    // console.log(tables[refTable]);

    // 해당 요금표 배열에서 cate1에 해당되는 요금 select
    if (cate1 === '개원의') {
      // console.log(tables[refTable].findIndex((item) => item.category === '전문의'));
      buff = tables[refTable][tables[refTable].findIndex((item) => item.category === '전문의')].fee;
    } else {
      for (let i = 0; i < tables[refTable].length; i++) {
        if (cate1 === tables[refTable][i].category) {
          buff = tables[refTable][i].fee;
        }
        // console.log(tables[refTable][i]);
      }
    }
    // console.log(buff);
    return buff;
  };

  renderTableRow(key, i) {
    return (
      <TableRow key={`registration-row-${i}`}>
        <TableCell component={'th'} width={'25%'} align={'center'}>
          {this.props.userInfo.country.indexOf('Korea') !== -1 ? key.value : key.valueEng}
        </TableCell>
        <TableCell width={'75%'}>
          {Object.entries(this.props.userInfo).map((data) => {
            if (data[0] === key.key) {
              if (key.key === 'regDate') {
                return moment(data[1]).format('YYYY-MM-DD HH:mm:ss');
              } else if (key.key === 'amount' && this.props.userInfo.regType && this.props.userInfo.regType !== 'R3') {
                const currency =
                  this.props.userInfo.country.indexOf('Korea') !== -1 || this.props.userInfo.lang === 'kor' ? 'KRW ' : 'USD ';

                if (key.value === '등록비') {
                  // if (this.props.userInfo.extraCharge) {
                  //   return currency + addComma(this.calculateRegistrationFee(this.props.userInfo) + this.props.userInfo.extraCharge);
                  // } else {
                  return currency + addComma(this.calculateRegistrationFee(this.props.userInfo));
                  // }
                } else {
                  // if (this.props.userInfo.isExtraCharge) {
                  //   return currency + addComma(this.props.userInfo.extraPaidAmount);
                  // } else {
                  return currency + addComma(data[1]);
                  // }
                }
              } else if (key.key === 'amount' && this.props.userInfo.regType && this.props.userInfo.regType === 'R3') {
                const currency = this.props.userInfo.lang === 'kor' ? 'KRW ' : 'USD ';
                if (key.value === '등록비') {
                  // if (this.props.userInfo.extraCharge) {
                  //   return currency + addComma(this.calculateRegistrationFee(this.props.userInfo) + this.props.userInfo.extraCharge);
                  // } else {
                  return currency + addComma(this.calculateRegistrationFee(this.props.userInfo));
                  // }
                } else {
                  // if (this.props.userInfo.isExtraCharge) {
                  //   return currency + addComma(this.props.userInfo.extraPaidAmount);
                  // } else {
                  return currency + addComma(data[1]);
                  // }
                }
              } else if (key.key === 'depositDate' || key.key === 'extraDepositDate') {
                return moment(data[1]).format('YYYY-MM-DD');
              } else if (key.key === 'status') {
                if (this.props.userInfo.isExtraCharge) {
                  if (this.props.userInfo.extraStatus && this.props.userInfo.extraStatus.indexOf('Complete') !== -1) {
                    return (
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} key={data[1]}>
                        <span style={{ color: '#00f', marginRight: '0.5em' }}>{this.props.userInfo.extraStatus}</span>
                        {/* <Button
                          variant="contained"
                          color="secondary"
                          size="small"
                          disableElevation
                          onClick={() => this.openReceipt(this.props.userInfo.regNo)}
                        >
                          Receipt
                        </Button> */}
                        {/* {moment().tz('Asia/Seoul').isAfter(moment('2021-11-11 23:59:59')) && (
                          <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            disableElevation
                            onClick={() => this.openCertificate(this.props.userInfo.regNo)}
                            style={{ marginLeft: '5px' }}
                          >
                            Certificate
                          </Button>
                        )} */}{' '}
                        <Button
                          variant="contained"
                          color="secondary"
                          size="large"
                          disableElevation
                          // onClick={() => this.openReceipt(this.props.userInfo.regNo)}
                          onClick={() => this.openReceipt()}
                          style={{ marginLeft: '8px', color: '#fff', textTransform: 'none', width: '140px' }}
                        >
                          Receipt
                        </Button>
                        {/* 무료등록 이수증 */}
                        <Button
                          variant="contained"
                          color="primary"
                          size="large"
                          disableElevation
                          // onClick={() => this.openCertificate(this.props.userInfo.regNo)}
                          onClick={() => {
                            if (moment().tz('Asia/Seoul').isAfter(moment('2022-11-11 08:00:00'))) {
                              this.openCertificate();
                            } else {
                              swal('', 'Available for download from 2022-11-13 18:30(KST)', 'info');
                            }
                          }}
                          style={{ marginLeft: '8px', textTransform: 'none', width: '140px' }}
                        >
                          Certificate
                        </Button>
                      </div>
                    );
                  } else {
                    return (
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} key={data[1]}>
                        <span style={{ color: '#f00', marginRight: '0.5em' }} key={data[1]}>
                          {this.props.userInfo.extraStatus && this.props.userInfo.extraStatus.indexOf('Wait') === -1
                            ? this.props.userInfo.extraStatus
                            : 'Payment needed'}
                        </span>
                        {!this.props.userInfo.extraPaidAmount && (
                          <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            disableElevation
                            onClick={() => this.props.movePage('/registration/submission')}
                          >
                            Go to registration
                          </Button>
                        )}
                      </div>
                    );
                  }
                } else {
                  if (data[1].indexOf('Complete') !== -1) {
                    return (
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }} key={data[1]}>
                        <span style={{ color: '#237a9d', fontWeight: 'bold', marginRight: '1em' }}>
                          {data[1].replace('Complete', 'Completed')}
                        </span>
                        <Button
                          variant="contained"
                          color="secondary"
                          size="large"
                          disableElevation
                          // onClick={() => this.openReceipt(this.props.userInfo.regNo)}
                          onClick={() => this.openReceipt()}
                          style={{ marginLeft: '8px', color: '#fff', textTransform: 'none', width: '140px' }}
                        >
                          Receipt
                        </Button>

                        {/* 무료등록 이수증 */}
                        <Button
                          variant="contained"
                          color="primary"
                          size="large"
                          disableElevation
                          // onClick={() => this.openCertificate(this.props.userInfo.regNo)}
                          onClick={() => {
                            if (moment().tz('Asia/Seoul').isAfter(moment('2022-11-11 08:00:00'))) {
                              this.openCertificate();
                            } else {
                              swal('', 'Available for download from 2022-11-13 18:30(KST)', 'info');
                            }
                          }}
                          style={{ marginLeft: '8px', textTransform: 'none', width: '140px' }}
                        >
                          Certificate
                        </Button>
                      </div>
                    );
                  } else {
                    return (
                      <span style={{ color: '#f00' }} key={data[1]}>
                        {data[1].indexOf('Wait') !== -1 ? 'Payment needed' : data[1]}
                      </span>
                    );
                  }
                }
              } else if (key.key === 'payType') {
                return data[1] === 'bank' ? 'Bank Transfer' : data[1];
              }

              // ** 2022 CUSTOM gala dinner
              // else if (key.key === 'isDinner') {
              //   return data[1] === 'O' ? 'KRW 30,000' : 'X';
              // } else if (key.key === 'cate3') {
              //   return data[1] === 'O' ? 'KRW 30,000' : 'X';
              // } else if (key.key === 'cate4') {
              //   return data[1] === 'O' ? 'KRW 30,000' : 'X';
              // }
              else if (key.key === 'cate3' || key.key === 'cate4') {
                return data[1] ? 'O' : 'X';
              }
              // else if (key.key === 'isDinner') {
              //   return data[1] ? 'O' : 'X';
              // }

              // data[1].indexOf('Complete') !== -1
              // else if (key.key === 'attach') {
              //   return !data[1] || data[1].length < 3 ? (
              //     'Not applicable'
              //   ) : (
              //     <span key={data[1]} onClick={(e) => this.handleDownload(data[1])} style={{ cursor: 'pointer' }}>
              //       <u>{data[1] && data[1].replace('evt120_', '').replace('%40', '@')}</u>
              //     </span>
              //   );
              // }
              // else if (key.key === 'attach' || data[0] === 'Document for proof of Resident') {
              //   return data[1] ? (
              //     <span key={data[1]} onClick={(e) => this.handleDownload(data[1])} style={{ cursor: 'pointer' }}>
              //       <u>{data[1] && data[1].replace('evt120_', '').replace('%40', '@')}</u>
              //     </span>
              //   ) : (
              //     ''
              //   );
              // }
              else {
                return this.categoryannual(data[1]);
              }
            }
          })}
        </TableCell>
      </TableRow>
    );
  }

  handleDownload(data) {
    fetch(`https://innon.s3.ap-northeast-2.amazonaws.com/PRS2022/attach/${data}`, { method: 'GET' })
      .then((res) => {
        return res.blob(); // raw 데이터를 받아온다
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(blob); // 받아온 날 상태의 data를 현재 window에서만 사용하는 url로 바꾼다
        const a = document.createElement('a');
        a.href = url;
        a.download = data.replace('evt120_', '').replace('%40', '@'); // 원하는 이름으로 파일명 지정
        document.body.appendChild(a);
        a.click(); // 자동으로 눌러버리기
        setTimeout((_) => {
          window.URL.revokeObjectURL(url); // 해당 url을 더 사용 못하게 날려버린다
        }, 60000);
        a.remove(); // a를 다 사용했으니 지워준다
      })
      .catch((err) => {
        console.error('err: ', err);
      });
  }

  spacing = (height) => {
    return (
      <Grid item xs={12}>
        <div style={height ? { height: `${height}px` } : { height: '20px' }} />
      </Grid>
    );
  };

  // UAE 국적 등록관련 함수
  //이미지 첨부 버튼 클릭
  clickUploadImg(event, type) {
    event.preventDefault();
    document.getElementById(`${type}`).click();
  }

  //input 태그 -> 실제로 이미지 바꾸는 코드
  handleChangeImg = async (event, type) => {
    this.setState({ attachLoading: true });
    if (event.target.files[0]) {
      let buff = this.state.figures;
      const targetFile = event.target.files[0];
      await readFile(targetFile, -1).then((file) => {
        for (let i = 0; i < buff.length; i++) {
          if (Number(type) === i) {
            buff[i] = targetFile;
          }
        }

        const userName = sessionStorage.getItem('_in_user_');
        const fileFormData = new FormData();
        fileFormData.append('evt', EVENT_ID);

        let idx = 0;
        let maxFile = 0;
        return new Promise(async (resolve, reject) => {
          await UploadToS3Alt(this.state.figures[0], 'PRS2022/attach', userName, 'attachment').then((upload) => {
            fileFormData.append(`attachment_DUP`, JSON.stringify(upload));
            idx++;
            if (idx === maxFile) {
              resolve(fileFormData);
            }
            this.setState({ attachLoading: false, figures: buff, isTraineeDoc: true });
          });
        });
        // this.setState({ figures: buff, isTraineeDoc: true });
      });
    }
  };

  deleteImg(_id, delItem) {
    // ** 2022 CUSTOM
    // 1.해당행사에서는 첨부 리셋용도로만 제공
    // 2.재첨부시에는 동일 파일명 덮어쓰기
    this.setState({ figures: [''] });
    if (this.state.isTraineeDoc && this.state.isTraineeDoc === true) {
      this.setState({ isTraineeDoc: false });
    }
  }

  saveChange() {
    if (this.state.figures[0]) {
      const userId = getUserID(true);
      let param = {
        evt: EVENT_ID,
        userId: userId,
      };
      param['attach'] = this.state.figures && getUserID() + '_' + this.state.figures[0].name;
      axiosInstance.put(`${WEB_API}/user/registration`, param).then((res) => {
        if (res) {
          swal('', 'changing complete.', 'success');
          this.setState({ toggleEdit: false });
          window.location.reload();
        }
      });
    } else {
      swal('', 'Please attach the edited image.', 'warning');
    }
  }

  render() {
    // console.log(this.state.figures);
    // console.log(this.props.userInfo, 'this.props.userInfo');
    return (
      <>
        <Grid container>
          {/* {this.state.data && ( */}
          {this.props.userInfo && (this.props.userInfo.isPay === 'R' || this.props.isFree) && (
            <>
              <Grid item xs={12}>
                <SubTitle>Registration Details</SubTitle>
              </Grid>
              <Grid item xs={12}>
                {/* {this.props.userInfo.payType === '무료등록' ? (
                  <div style={{ textAlign: 'center', fontSize: '1.5em' }}>{this.props.userInfo.username} 님은 무료등록 대상자입니다.</div> */}
                {
                  // this.props.isFree ||
                  this.props.userInfo.payType === '무료등록' || (this.props.userInfo.amount && this.props.userInfo.amount == 0)
                    ? this.renderFreeMember()
                    : this.renderRegistrationDetail()
                }
              </Grid>
              {/* {this.state.data.paymentMethod === 'Bank Transfer' && ( */}
              {this.props.userInfo.payType === 'bank' && (
                <>
                  {this.spacing(30)}
                  <Grid item xs={12}>
                    <SubTitle>{this.props.userInfo.country.indexOf('Korea') !== -1 ? '은행 송금 정보' : 'Bank Information'}</SubTitle>
                  </Grid>
                  <Grid item xs={12}>
                    {this.renderBankTransfer()}
                  </Grid>
                </>
              )}
            </>
          )}
          {this.spacing(30)}
          <Grid item xs={12}>
            <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
              {/* {!this.state.data.id && ( */}
              {this.props.userInfo.isPay !== 'R' && (
                <>
                  <ConfirmButton color="primary" onClick={() => this.props.movePage('/registration/submission')}>
                    Go to registration
                  </ConfirmButton>
                  <div style={{ width: '20px' }} />
                </>
              )}
              <ConfirmButton
                // variant="outlined"
                color="primary"
                onClick={() => {
                  if (this.props.isMypage) this.props.handleState('sidx', 0);
                }}
              >
                Home
              </ConfirmButton>
            </div>
          </Grid>
        </Grid>
      </>
    );
  }
}

export default withStyles(styles)(RegistrationPreview);
